/**
 * EL NOMBRE QUE VA ARRIBA ES EL DEL NEGOCIO (12-oct-2026).
 *
 * Kervens: «a partir de hoy, Conversia no se llama Conversia… allá arriba, donde dice
 * Conversia, vas a poner el nombre del negocio del cliente». El sistema no se nombra en el
 * panel: se ve el negocio, con su sello y con una estética que vaya con lo que representa.
 */

/** El negocio de esta instalación, mientras el servidor no ha dicho su nombre. */
export const NEGOCIO = 'Rich Real Estate';

/** Las iniciales del negocio para su sello: «Rich Real Estate» → «RR». PURO. */
export function inicialesDe(nombre: string): string {
  const palabras = nombre.trim().split(' ').filter(Boolean);
  return (palabras.slice(0, 2).map((p) => p[0]).join('') || '·').toUpperCase();
}
